/**
 * plugins/index.ts
 *
 * Automatically included in `./src/main.ts`
 */

// Plugins
import vuetify from './vuetify'
import router from '../router'
import { createHead } from '@vueuse/head'
import VCalendar from 'v-calendar'
import 'v-calendar/style.css'
import '../assets/styles/main.scss'

// Sdílená pinia instance (s persistedstate pluginem)
import pinia from '../stores/persist/persist'

// i18n plugin
import { i18n } from './i18n'

// Types
import type { App } from 'vue'

export function registerPlugins (app: App) {
  const head = createHead()

  // DŮLEŽITÉ: Pořadí registrace je kritické!
  // 1. Pinia musí být první (store může být použit v jiných pluginech)
  // 2. i18n druhý (může být použit v komponentách a routeru)
  // 3. Router třetí (závisí na pinia a i18n)
  // 4. Ostatní pluginy
  app
    .use(pinia)
    .use(i18n)
    .use(router)
    .use(vuetify)
    .use(head)
    .use(VCalendar, {})
}
